export interface ITableDto {
    name: string;
    guid: string;
    form: string;
    year: string;
    section: string;
    questions: string[];
    countries: string[];
    final?: boolean;
}

export const tableDtoInit: ITableDto = {
    name: "",
    guid: "",
    form: "",
    year: "",
    section: "",
    questions: [],
    countries: [],
};

export interface ITableFilter
    extends Omit<ITableDto, "guid" | "section" | "questions" | "countries"> {
    name: string;
}

export const tableFilterInit: ITableFilter = {
    form: "",
    year: "",
    name: "",
};
